import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { empty } from '@/lib/functions/dom-helpers';

@Component({
	mounted() {
		this.togglerId = `code-preview-bg-toggler-${this._uid}`;
		this.codeWrapperId = `dynamic-code-${this._uid}`;

		this.$nextTick().then(() => {
			this.createDynamicElement();
		});
	}
})
export default class CodePreview extends Vue {
	codeWrapperId: string = '';
	togglerId: string = '';
	codeInstance: Vue | null = null;
	isPreviewBgTransparent: boolean = false;
	error: TypeError | null = null;

	@Prop({
		default: ''
	})
	code!: string;

	@Watch('code')
	handleCodeChange(newValue: string, oldValue: string) {
		if (oldValue !== newValue) {
			/**
			 * $codeWrapper which is used in undermentioned methods can be null
			 */
			this.$nextTick().then(() => {
				this.clearPrevInstance();
				this.createDynamicElement();
			});
		}
	}

	/**
	 * Takes markup from code slot, inject to code wrapper na create Vue instance and pass wrapper as root
	 */
	createDynamicElement(): void {
		const $instanceWrapper: HTMLElement = <HTMLElement>this.$refs.instanceWrapper;
		const $codeWrapper: Element | null = $instanceWrapper.querySelector(`#${this.codeWrapperId}`);
		const self = this;

		if (this.$props.code && $codeWrapper) {
			$codeWrapper.insertAdjacentHTML('afterbegin', this.$props.code);

			this.codeInstance = new Vue({
				el: `#${this.codeWrapperId}`,

				errorCaptured(err: TypeError) {
					self.handleMarkupError(err);

					return false;
				}
			});

			if (!$instanceWrapper.querySelector(`#${this.codeWrapperId}`)) {
				this.handleInstanceCreationError();
			} else {
				this.error = null;
			}
		}
	}

	handleMarkupError(err: TypeError): void {
		this.error = err;
		this.clearPrevInstance();
	}

	handleInstanceCreationError(): void {
		this.createCodeWrapper();
		this.error = new Error('Error przy tworzeniu instancji vue, najprawdopodobniej bład kompilacji szablonu');
	}

	createCodeWrapper(): void {
		const $instanceWrapper: HTMLElement = <HTMLElement>this.$refs.instanceWrapper;
		const $codeWrapper = document.createElement('div');

		$codeWrapper.setAttribute('id', this.codeWrapperId);

		$instanceWrapper.append($codeWrapper);
	}

	clearPrevInstance(): void {
		const $instanceWrapper: HTMLElement = <HTMLElement>this.$refs.instanceWrapper;

		const $codeWrapper: Element | null = $instanceWrapper.querySelector(`#${this.codeWrapperId}`);
		if (this.codeInstance) {
			this.codeInstance.$destroy();
			this.codeInstance = null;
		}

		if ($codeWrapper) {
			empty($codeWrapper);
		}
	}
}
